<template>
    <div class="row">
        <div class="col-sm-12">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive table-desi table-product">
                        <v-data-table-server
                            class="table table-1d all-package blogGrid"
                            v-model:items-per-page="itemsPerPage"
                            :search="search"
                            :headers="showHeaders"
                            :items-length="pagination.total"
                            :items="dataGrid"
                            :loading="loading"
                            item-value="name"
                            @update:options="getGrid"
                        >
                            <template v-slot:thead>
                                <tbody>
                                    <tr>
                                        <td v-if="selectedHeaders.includes('id')">
                                            <v-text-field v-model="id" hide-details placeholder="Search id..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('name')">
                                            <v-text-field v-model="name" hide-details placeholder="Search name..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('address')">
                                            <v-text-field v-model="address" hide-details placeholder="Search address..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('addressnumber')">
                                            <v-text-field v-model="addressnumber" hide-details placeholder="Search addressnumber..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('city')">
                                            <v-text-field v-model="city" hide-details placeholder="Search city..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('email')">
                                            <v-text-field v-model="email" hide-details placeholder="Search email..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('phone')">
                                            <v-text-field v-model="phone" hide-details placeholder="Search phone..." class="ma-2" density="compact"></v-text-field>
                                        </td>
                                        <td v-if="selectedHeaders.includes('actions')"></td>
                                    </tr>
                                </tbody>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn color="primary" class="elevation-0" icon variant="plain" @click="edit(item)"> <v-icon> mdi-pencil-outline </v-icon> </v-btn>
                                <v-btn color="error"   class="elevation-0" icon variant="plain" @click="openDeleteDialog(item)"><v-icon> mdi-trash-can-outline </v-icon> </v-btn>

                                <v-dialog v-model="dialogDelete" max-width="600px">
                                    <v-card>
                                        <v-card-title class="confirmation-dialog" primary-title>Confirmation</v-card-title>
                                        <v-card-text> Are you sure you want to delete the vendor with the name '{{ selectedItem.name }}'? </v-card-text>
                                        <v-card-actions>
                                            <v-btn color="red"   text @click="dialogDelete = false">Cancel</v-btn>
                                            <v-btn color="green" text @click="deleteItem(selectedItem)">Delete</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                        </v-data-table-server>
                        <v-alert v-if="messageError != ''" :type="typeOfMessage" :text="messageError"></v-alert>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { objectExpression } from '@babel/types'

export default {
    title: 'Vendors',
    props: {},
    data() {
        return {
            dataGrid: ref([]),
            pagination: ref({
                from: 0,
                to: 0,
                total: 0,
                current: 1,
                lastPage: 0
            }),
            itemsPerPage: 10,
            selectedHeaders: ['name', 'address',  'city', 'email', 'phone','actions'],
            headers: [
                {
                    title: 'ID',
                    align: 'start',
                    sortable: true,
                    key: 'id'
                },
                {
                    title: 'Name',
                    align: 'center',
                    sortable: true,
                    key: 'name'
                },
                {
                    title: 'Address',
                    align: 'center',
                    sortable: true,
                    key: 'address'
                },
                
                {
                    title: 'City',
                    align: 'center',
                    sortable: true,
                    key: 'city'
                },
                
                {
                    title: 'Email',
                    align: 'center',
                    sortable: true,
                    key: 'email'
                },
            
                {
                    title: 'Phone',
                    align: 'center',
                    sortable: true,
                    key: 'phone'
                },
                {
                    title: 'Active',
                    align: 'center',
                    sortable: true,
                    key: 'active',
                    value: 'active'
                },
                {
                    title: 'Actions',
                    align: 'center',
                    sortable: false,
                    key: 'actions'
                }
            ],
            loading: true,

            // Filtros search
            search: '',
            id: '',
            name: '',
            address: '',
            addressnumber: '',
            city: '',
            email: '',
            phone: '',

            selectedItem: null,
            dialogDelete: false,
            messageError: '',
            typeOfMessage: ''
        }
    },
    watch: {
        id() {
            this.search = String(Date.now())
        },
        name() {
            this.search = String(Date.now())
        },
        address() {
            this.search = String(Date.now())
        },
        city() {
            this.search = String(Date.now())
        },
        email() {
            this.search = String(Date.now())
        },
        phone() {
            this.search = String(Date.now())
        }
    },
    computed: {
        //Done to get the ordered headers
        showHeaders() {
            return this.headers.filter((s) => this.selectedHeaders.includes(s.key))
        }
    },
    methods: {
        openDeleteDialog(item) {
            this.selectedItem = item;
            this.dialogDelete = true;
        },
        getGrid({ page, itemsPerPage, sortBy, search }) {
            let self = this
            this.loading = true
                                                                                                                
            //Aplicamos los filtros
            let apiURL = process.env.VUE_APP_URL_API_BASE + '/vendor/grid?page=' + page + '&limit=' + itemsPerPage + '&id=' + self.id 
                        + '&name=' + self.name + '&address=' + self.address +  '&city=' + self.city 
                        + '&email=' + self.email + '&phone=' + self.phone

            //Aplicamos el orden
            if (sortBy && sortBy[0]) {
                apiURL = apiURL + '&sort=' + sortBy[0].key + '&order=' + sortBy[0].order
            }

            return new Promise(async (resolve, reject) => {
                let status = 'Success'
                await axios({
                    url: apiURL,
                    method: 'GET',
                    data: {},
                    responseType: 'json'
                }).then((response) => {
                    if (response.data) {

                        // Obtenemos la data de dentro de blog guardandola en dataGrid
                        self.dataGrid = []
                        response.data.data.forEach(function (option) {
                            if (option) {
                                self.dataGrid.push(option)
                            }
                        })

                        self.pagination.from = response.data.from
                        self.pagination.to = response.data.to
                        self.pagination.total = response.data.total
                        self.pagination.current = response.data.current_page
                        self.pagination.lastPage = response.data.last_page
                        this.loading = false
                        status = 'Success'
                    }
                })
                resolve(status)
            })
        },
        new(item) {
            this.$router.push({ name: "add_vendor"});
        },
        edit(item) {
            this.$router.push({ path: "edit_vendor/" + item.id });
        },
        async deleteItem(item)  {
            let newObject = {
                id: item.id
            }
            await axios.post('http://localhost:8001/admin/vendor/delete', newObject, {
                responseType: 'json' // Especifica el tipo de respuesta
            }).then((response) => {
                if (response.data.error) {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.data.message
                    this.typeOfMessage = 'success'
                }

                setTimeout(() => (this.messageError = ''), 10000)
            })
            .catch((error) => {
                this.messageError = 'Error! El registro no se ha eliminado.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 10000)
                console.error("Error:",error)
            })

            let paramsGrid = {
                page: this.pagination.current ,
                itemsPerPage: this.itemsPerPage
            }
            await this.getGrid(paramsGrid); 
            this.dialogDelete = false;
        }
    }

    /* async mounted() {
        await this.getGrid()
    }  */
}
</script>

<style></style>
